var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "saved-report-form",
      on: {
        submit: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.savedReport.name,
            expression: "savedReport.name"
          }
        ],
        staticClass: "f-s-14 form-control",
        attrs: {
          placeholder: _vm.$t("DEFAULT_REPORT_NAME"),
          type: "text",
          "data-testid": "v2-reporting-saved-report-name-input"
        },
        domProps: { value: _vm.savedReport.name },
        on: {
          change: _vm.onReportNameChange,
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.savedReport, "name", $event.target.value)
          }
        }
      }),
      _vm._v(" "),
      !_vm.savedReport.id
        ? _c("SaveReportBtn", {
            attrs: {
              "icon-class": "fa fa-floppy-o",
              disabled: !_vm.savedReport.name,
              label: _vm.$t("SAVE"),
              tooltip: _vm.$t("SAVE_TT"),
              "update-only": false,
              "is-admin": _vm.isAdmin,
              type: "primary"
            },
            on: { onSaveReport: _vm.saveReport }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.savedReport.id
        ? _c("SaveReportBtn", {
            attrs: {
              "icon-class": "fa fa-floppy-o",
              disabled: !_vm.savedReport.name,
              label: _vm.$t("UPDATE_REPORT"),
              tooltip: _vm.$t("UPDATE_REPORT_TT"),
              "update-only": true,
              type: "primary"
            },
            on: { onSaveReport: _vm.saveReport }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.savedReport.id
        ? _c("SaveReportBtn", {
            attrs: {
              "icon-class": "fa fa-clone",
              disabled: !_vm.savedReport.name,
              tooltip: _vm.$t("SAVE_AS_TT"),
              "is-admin": _vm.isAdmin
            },
            on: { onSaveReport: _vm.saveReportAs }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.savedReport.id
        ? _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip.bottom",
                value: _vm.$t("DELETE_TT"),
                expression: "$t('DELETE_TT')",
                modifiers: { bottom: true }
              }
            ],
            staticClass: "btn btn-function fa fa-trash f-s-16 m-l-10",
            attrs: { "data-testid": "v2-reporting-saved-report-delete-btn" },
            on: { click: _vm.showDeleteConfirmationModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showDeleteConfirmation
        ? _c(
            "ConfirmationModal",
            {
              attrs: {
                entity: _vm.savedReport,
                title: _vm.$t("DELETE_CONFIRMATION_TITLE"),
                "confirm-action-text": _vm.$t("DELETE")
              },
              on: {
                confirm: _vm.deleteReport,
                close: function($event) {
                  _vm.showDeleteConfirmation = false
                }
              }
            },
            [
              _c("p", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "DELETE_MESSAGE",
                    expression: "'DELETE_MESSAGE'"
                  }
                ]
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }